import { IS_AUTO_TEST_HIDE } from 'reactApp/appHelpers/configHelpers';
import { storeHelper } from 'reactApp/modules/promo/promo.helpers';
import { addPromoToShowQueue, promoShown, removePromo } from 'reactApp/modules/promo/promo.module';
import { EPromoType } from 'reactApp/modules/promo/promo.types';
import { getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import { getStorage } from 'reactApp/modules/storage/storage.helpers';
import { store } from 'reactApp/store';
import { CLOUD_NEW_FEATURES_TOOLTIP_ID_MOBILE } from 'reactApp/ui/CloudNewFeatures/CloudNewFeatures.helpers';
import { put, select } from 'redux-saga/effects';

export function* initCloudNewFeaturesMobilePromo() {
    const storage = yield select(getCurrentStorage);
    const { isHome } = getStorage(storage);

    if (!isHome || IS_AUTO_TEST_HIDE || storeHelper.getValue(CLOUD_NEW_FEATURES_TOOLTIP_ID_MOBILE)) {
        return;
    }

    yield put(
        addPromoToShowQueue({
            type: EPromoType.newFeaturesMobile,
            promoId: CLOUD_NEW_FEATURES_TOOLTIP_ID_MOBILE,
            onShow: () => {
                store.dispatch(promoShown(EPromoType.newFeaturesMobile));
                storeHelper.markAsShown(CLOUD_NEW_FEATURES_TOOLTIP_ID_MOBILE);
            },
            onClose: () => {
                store.dispatch(removePromo(EPromoType.newFeaturesMobile));
            },
        })
    );
}
